module.exports = __webpack_public_path__ + "static/img/fulo.aa9af9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulo.png
// module id = S7zr
// module chunks = 1